import { POST } from '@/api'

export default {
  namespaced: true,
  state: {
    busy: false,
  },
  mutations: {
    busy(state, busy) {
      state.busy = busy
    },
  },
  actions: {
    async saveSmsName({ commit, state }, { displayName }) {
      if (state.busy) return false
      commit('busy', true)

      const { status, message } = await POST('/api/web/ivr/name/update', { displayName })
      if (status !== 200) commit('app/error', { status, message }, { root: true })

      commit('busy', false)
      return status === 200
    },

    async saveTimeLimit({ commit, state }, { deadlines }) {
      if (state.busy) return false
      commit('busy', true)

      const { status, message } = await POST('/api/web/ivr/deadline/update', { deadlines })
      if (status !== 200) commit('app/error', { status, message }, { root: true })

      commit('busy', false)
      return status === 200
    },

    async saveTerms({ commit, state }, terms) {
      if (state.busy) return false
      commit('busy', true)

      const { status, message } = await POST('/api/web/ivr/reception/terms/register', terms)
      if (status !== 200) commit('app/error', { status, message }, { root: true })

      commit('busy', false)
      return status === 200
    },

    async saveWeeks({ commit, state }, weeks) {
      if (state.busy) return false
      commit('busy', true)

      const { status, message } = await POST('/api/web/ivr/reception/weeks/register', weeks)
      if (status !== 200) commit('app/error', { status, message }, { root: true })

      commit('busy', false)
      return status === 200
    },

    async updateStauts({ commit, state }, active) {
      if (state.busy) return false
      commit('busy', true)

      const { status, message } = await POST('/api/web/ivr/status/update', active)
      if (status !== 200) commit('app/error', { status, message }, { root: true })

      commit('busy', false)
      return status === 200
    },

    async delete(store, id) {
      const { commit, state } = store
      if (state.busy) return false
      commit('busy', true)

      const { status, message } = await POST('/api/web/ivr/reception/delete', id)
      if (status !== 200) {
        commit('app/error', { status, message }, { root: true })
      }

      commit('busy', false)
      return status === 200
    },
  },
}
